import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class PhysicalLocationOperatingRoom implements IDataStorage {
  index: InternalIndex = new InternalIndex('Id', 'Id', true, false);
  tableDefinition: InternalTable = new InternalTable('PhysicalLocationOperatingRoom', 'Id', true, [
    this.index
  ]);

  Id: number;
  Name: string;
  PhysicalLocationId: number;

  static getTableDefinition(): InternalTable {
    return new PhysicalLocationOperatingRoom().tableDefinition;
  }
}
